import type {ReactNode} from 'react';
import styles from './Container.module.scss';

interface ContainerProps {
    children: ReactNode;
    className?: string;
}

/** Plain stand-in for MUIContainer: same width and side gutters at every breakpoint. */
const Container = ({children, className}: ContainerProps) => (
    <div className={className ? `${styles.container} ${className}` : styles.container}>{children}</div>
);

export default Container;
